<!-- <mat-card> -->
<iframe width="600" height="772" src="https://lookerstudio.google.com/embed/reporting/57fb8334-62e3-43d8-bc29-b77dc320e5bf/page/v0LNB" frameborder="0" style="border:0" allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
<!-- </mat-card> -->
<!-- <form #loginForm="ngForm">
  <mat-toolbar><span style="margin-top:5px">Resum per any:</span>
    <mat-select placeholder="Resum per l'any" style="float:left;margin-left:20px" name="currAny" [(ngModel)]="currAny">
      <mat-option *ngFor="let unAny of anys" [value]="unAny">{{unAny}}</mat-option>
    </mat-select>
    <button md-icon-button md-tooltip="Actualitzar" (click)="refrescar()" style="float: right; margin-left: 10px">
        <mat-icon color="primary">done</mat-icon>
    </button>
    <button md-icon-button md-tooltip="Exportar la llista" alt="Exportar" (click)="this.export()" style="float: right; margin-right: 20px">
      <mat-icon color="primary">vertical_align_bottom</mat-icon>
    </button>
  </mat-toolbar>

<mat-tab-group #tabs>
  <mat-tab label="Totals">
  <mat-card-content *ngIf="res1" style="padding-top:30px">
       
        <div style="float:left;clear:none;width:100%;font-size:1.2em;font-weight:bold;height:30px">Total projectes per empresa</div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri MCRIT AIE</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendents cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Iniciat"].Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["En curs"].Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'].Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Tancat"].Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Catalunya["Total"].Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri MCRIT AIE'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Multicriteri'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Multicriteri'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">MCRIT</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['MCRIT'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['MCRIT'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Geovincles</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Geovincles'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Geovincles'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Ersília</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res1['Ersília'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res1['Ersília'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>
  </mat-card-content>
  </mat-tab>
  
  <mat-tab label="Sistemes">

  <mat-card-content *ngIf="res2" style="padding-top:30px">

        <div style="float:left;clear:none;width:100%;font-size:1.2em;font-weight:bold;height:30px">Projectes de sistemes per empresa</div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri MCRIT AIE</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri MCRIT AIE'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Multicriteri'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Multicriteri'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">MCRIT</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['MCRIT'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['MCRIT'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Geovincles</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Geovincles'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Geovincles'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Ersília</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res2['Ersília'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res2['Ersília'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>
  </mat-card-content>
  </mat-tab>

  <mat-tab label="Subcontractació">

  <mat-card-content *ngIf="res3" style="padding-top:30px">

        <div style="float:left;clear:none;width:100%;font-size:1.2em;font-weight:bold;height:30px">Subcontractació per empresa</div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri MCRIT AIE</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri MCRIT AIE'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Multicriteri'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Multicriteri'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">MCRIT</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['MCRIT'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['MCRIT'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Geovincles</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Europa["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Geovincles'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Geovincles'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Ersília</div>

        <div style="float:left; clear:left; width:250px;font-size:1.0em;font-weight:normal;text-align:center;height:30px">
          TOTS
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Iniciats
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          En curs
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Finalitzats pendent cobrament
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Tancat
        </div>
        <div style="float:left;clear:none;width:200px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Totals
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Catalunya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Catalunya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Catalunya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Catalunya["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Europa
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Europa["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Europa["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Europa["Total"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Internacional
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Internacional["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Internacional["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Internacional["Total"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Espanya
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["Iniciat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["Iniciat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["En curs"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["En curs"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya['Finalitzat pendent de cobrament'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya['Finalitzat pendent de cobrament'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["Tancat"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Espanya["Tancat"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res3['Ersília'].Espanya["Total"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right"> 
          &nbsp;{{res3['Ersília'].Espanya["Total"] .Pressupost || 0 | number}}
        </div>
  </mat-card-content>
 </mat-tab>

  <mat-tab label="Public i privats">
  <mat-card-content *ngIf="res4" style="padding-top:30px">

    <div style="float:left;clear:none;width:100%;font-size:1.2em;font-weight:bold;height:30px">Projectes públics i privats per empresa</div>

    <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri MCRIT AIE</div>

    <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
      &nbsp;
    </div>
    <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
      Nombre
    </div>
    <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
      Pressupost
    </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients públics
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri MCRIT AIE']["Privats"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri MCRIT AIE']["Privats"] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients privats
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri MCRIT AIE']["Publics"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri MCRIT AIE']["Publics"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients públics
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri']["Privats"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri']["Privats"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients privats
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri']["Publics"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Multicriteri']["Publics"] .Pressupost || 0 | number}}
        </div>


        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">MCRIT</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients públics
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['MCRIT']["Privats"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['MCRIT']["Privats"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients privats
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['MCRIT']["Publics"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['MCRIT']["Publics"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Geovincles</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients públics
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Geovincles']["Privats"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Geovincles']["Privats"] .Pressupost || 0 | number}}
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Projectes de clients privats
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res4['Geovincles']["Publics"].Nombre}}
      </div>
      <div style="float:left;clear:none;width:100px;text-align:right">
        &nbsp;{{res4['Geovincles']["Publics"] .Pressupost || 0 | number}}
      </div>

      <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Ersília</div>

      <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
       Projectes de clients públics2
      </div>
      <div style="float:left;clear:none;width:100px;text-align:right">
        &nbsp;{{res4['Ersília']["Privats"].Nombre}}
      </div>
      <div style="float:left;clear:none;width:100px;text-align:right">
        &nbsp;{{res4['Ersília']["Privats"] .Pressupost || 0 | number}}
      </div>

      <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
       Projectes de clients privats
      </div>
      <div style="float:left;clear:none;width:100px;text-align:right">
        &nbsp;{{res4['Ersília']["Publics"].Nombre}}
      </div>
      <div style="float:left;clear:none;width:100px;text-align:right">
        &nbsp;{{res4['Ersília']["Publics"] .Pressupost || 0 | number}}
      </div>
  </mat-card-content>
  </mat-tab>

  <mat-tab label="Facturació">
  <mat-card-content *ngIf="res5" style="padding-top:30px">

    <div style="float:left;clear:none;width:100%;font-size:1.2em;font-weight:bold;height:30px">Facturació per empresa</div>

        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri MCRIT AIE</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
           &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Nombre
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures emeses i cobrades
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']['cobrades'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']['cobrades'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de cobrament
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']["pendents_cobrar"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']['pendents_cobrar'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de fer
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']["pendents_fer"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri MCRIT AIE']['pendents_fer'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Multicriteri</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
           &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures emeses i cobrades
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']['cobrades'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']['cobrades'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de cobrament
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']["pendents_cobrar"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']['pendents_cobrar'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de fer
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']["pendents_fer"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Multicriteri']['pendents_fer'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">MCRIT</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
           &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures emeses i cobrades
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']['cobrades'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']['cobrades'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de cobrament
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']["pendents_cobrar"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']['pendents_cobrar'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de fer
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']["pendents_fer"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['MCRIT']['pendents_fer'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Geovincles</div>

        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
           &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures emeses i cobrades
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']['cobrades'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']['cobrades'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de cobrament
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']["pendents_cobrar"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']['pendents_cobrar'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de fer
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']["pendents_fer"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Geovincles']['pendents_fer'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:none;width:100%;font-size:1.1em;font-weight:bold;height:30px">Ersília</div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
           &nbsp;
        </div>
        <div style="float:left;clear:none;width:100px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
          Pressupost
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures emeses i cobrades
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']['cobrades'].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']['cobrades'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de cobrament
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']["pendents_cobrar"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']['pendents_cobrar'] .Pressupost || 0 | number}}
        </div>
        <div style="float:left;clear:left;width:250px;text-align:center;font-size:1.0em;font-weight:normal;height:30px">
         Factures pendents de fer
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']["pendents_fer"].Nombre}}
        </div>
        <div style="float:left;clear:none;width:100px;text-align:right">
          &nbsp;{{res5['Ersília']['pendents_fer'] .Pressupost || 0 | number}}
        </div>

  </mat-card-content>
  </mat-tab>


 </mat-tab-group>
 </form>-->

